import { resourceQuery } from '@webapp-next/lib/request/webapp/resource-query';
import { Workplace } from '@/modules/people/types/people-setup';
import Employee from '@/modules/people/types/employee';

type AgreedHourWeek = {
  days: Array<{
    shifts: Array<{
      location: Workplace;
    }>;
  }>;
};

export function getAgreedShiftLocations(
  agreedHourWeeks: AgreedHourWeek[] = []
): Workplace[] {
  return agreedHourWeeks.reduce<Workplace[]>((allAreas, currentWeek) => {
    const { days } = currentWeek;

    const weekAreas = days.reduce<Workplace[]>((dayAreas, currentDay) => {
      const { shifts } = currentDay;
      const shiftsAreas = shifts.map(({ location }) => location);
      dayAreas = [...dayAreas, ...shiftsAreas];
      return dayAreas;
    }, []);

    allAreas = [...allAreas, ...weekAreas];
    return allAreas;
  }, []);
}

export async function getJobPositionsInAlphaOrder(): Promise<
  Employee['Position'][]
> {
  const employeesWithUniqueJobPositions = await resourceQuery('Employee', {
    search: [{ field: 'Position', type: 'is', data: '' }],
    group: ['Position'],
  });

  const positionsWithValues = employeesWithUniqueJobPositions.filter(
    emp => emp.Position
  );

  return positionsWithValues.map(emp => emp.Position).sort();
}
